import { Link } from "react-router-dom";

export const Logo = () => {
  return (
    <Link
      to="/"
      data-testid="logo-home-link"
      className="flex items-center gap-2.5 group"
    >
      <svg
        width="30"
        height="30"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0 transition-transform duration-500 group-hover:rotate-[8deg]"
      >
        <circle cx="50" cy="50" r="46" fill="#161311" stroke="#D97757" strokeWidth="4" />
        <path
          d="M50 20 C35 35 35 65 50 80 C65 65 65 35 50 20 Z"
          fill="none"
          stroke="#D97757"
          strokeWidth="3"
        />
        <path
          d="M30 50 C40 38 60 38 70 50 C60 62 40 62 30 50 Z"
          fill="none"
          stroke="#528A6E"
          strokeWidth="3"
        />
        <circle cx="50" cy="50" r="6" fill="#D97757" />
      </svg>
      <span className="font-heading text-lg sm:text-xl leading-none tracking-tight text-tira-text">
        Tira<span className="text-tira-accent italic"> Spa</span>
      </span>
    </Link>
  );
};
